import generateNotes from "./generate";

const Notes = generateNotes(
  "Season 2: Soulbound Patch Notes",
  "Releases on May 3rd, 2025",
  `
- General
  - Soulbound Boss Fights
    - Soulbound Boss Fights have been introduced into the game, offering a cooperative way to play.
    - In Soulbound Boss Fights, you'll face a random boss as a team of 3 players and be given 3 attempts and 15 minutes to defeat the boss.
    - If you succeed, you'll be rewarded with some equippable items that make you stronger, and if you continue to succeed you'll rank up.
    - Losing has no penalty unless you're in Grand Titan, where boss difficulty grows indefinitely with your internal rating.
    - The higher your rank, the harder the bosses will be, and the better the rewards will be.
    - At silver and above, bosses will also receive additional powerup buffs adding more mechanics to deal with during the fights.
    - You can choose to filter which rank you'd like to face when you queue to enter a boss fight.
    - You can sell unwanted equipment for Titan Points and purchase better gear from the Shop.
    - The shop will have random equipment available that you can purchase with Titan Points.
      - The Equipment Shop resets every 3 hours, and is different for each player + Titan.
    - Equipment and boss fight rank is unique for each Titan you play.
    - You can trade equipment and Titan Points with other players in game for a small fee in Titan Points.
    - You're now able to inspect players in the world to see what equipment they have.
    - Chain Breaker cannot be used during Soulbound Boss Fights.
  - Season 2
    - In Season 2, all Runes will be unlocked for everyone by default.
    - All Titan Points will be wiped - if you have extra unused Titan Points, please convert them to Obols before the season starts. You can do so in the Shop in the Misc tab.
      - Titan Points will now be used as the item currency for Soulbound Boss Fights.
    - Items equipped from Soulbound Boss Fights will have no impact in PvP arena matches.
    - The new Season 2 titles are now available in the shop and can be acquired when you hit the required rank for each title.
    - All healing done in duels is now reduced by 75% (was: 50%).
    - There are 3 new general talents
      - Cower: Reduce your threat by 30%.
      - Menace: Increase your threat by 30%.
      - Solace: Increase all outgoing healing by 5%.
    - There are new cosmetics in the shop, including:
      - A Dragon Mount based on one of the Soulbound Bosses (Smolderak).
      - Classic Skins for each Titan (the same models from the early access version).
      - New epic weapons.
  - Improvements
    - Improved the main menu UI with easier navigation.
      - Other various UI improvements as well such as darker backgrounds to make things easier to read.
      - UI tabs are now highlighted when active.
      - Opening large windows now automatically closes other large windows that were open to prevent UI clutter.
      - Removed some unnecessary UI animations when certain UI elements appeared on screen.
    - Updated the lobby layout.
      - Players now spawn directly in the town.
      - The training area has been moved to just outside the town border.
      - Practice targets now have their own unique models instead of reusing Titan models.
      - Fixed some floating models/flowers and removed some invisible colliders.
    - Reduced the fog and saturation to increase visual clarity.
    - Added colored outlines around Titan models to make it easier to see your target, focus and mouseover.
    - Added colored outlines around the Titan Frame and Titan Nameplate of your target and focus.
    - The circles underneath your self, focus, and mouseover now match the highlight colors, and there is also now a circle for your mouseover target.
    - Added new DPS, Healing, and Threat meter UIs to help theorycraft and compare with other players.
    - When entering a lobby in a party, you'll now always enter the same lobby as your party members if multiple lobbies exist.
    - Overhealing no longer counts as healing done.
    - The Combat Log now shows when buffs are added and removed.
    - When typing /dance into chat, you'll get an explaination of how to emote.
    - When typing /m or /macro into chat, you'll get an explanation how to set spells to cast on specific targets.
    - If at Grand Titan, you'll now see your current MMR on the queue screen.
  - Fixes
    - Fixed an issue which would rarely cause buffs/debuffs to sometimes last longer than intended.
    - Fixed overflowing health numbers on Titan Frames and Titan Nameplates in certain cases.
    - DR timers and floating text is now synced on the server instead of being client side predicted.
      - This fixes the issue where your client thought you landed a spell but the server didn't, causing incorrect DR timers to show up and incorrect floating text.
    - Improved latency and reliability of server DB writes.
    - Fixed an issue where successful casts would sometimes appear incomplete on the UI for a small period of time.
    - Fixed an issue causing mount walk/run animations to last longer than they should after stopping moving.
    - Sound effects are now muted during intro cinematics.
    - Fixed the look direction of your character's head being slightly too high while mounted.
    - Fixed an issue where you could accept two outstanding party invites at once.
    - Prevented any invites from showing while you are in a match (such as party or trade invites).
    - Fixed an issue causing error logs to spam when using multiple actions on a single keybind.
    - Fixed an issue causing Titan Models to flicker on the main menu while entering a new world server.
    - Fixed an issue preventing chatting during replays or while spectating.
    - Fixed a minor one-frame UI flicker on Titan Nameplates when new Titans appear in the world.
    - Fixed an issue causing permanent auth failures during the Tuesday Steam maintenance window even after the maintenance ended.
    - Fixed an issue causing internal Titan classes to show on the copy keybinds dropdown.
    - Fixed an issue preventing seeking from working correctly in Replays.
    - Fixed an issue preventing clients from being unable to reconnect to an active match.
  - Balance
    - Hunter Orin
      - The Hunter Orin passive has been changed to "Every time you take physical damage, reduce the cooldown on Dissociative Force by 5% of the remaining duration.".
`
);

export default Notes;
